import {acetabulumPointTypes, femoralHeadPointTypes, tearDropPointTypes} from "../../markup/MarkupPointTypes";
import MainMeasureResult from "../MainMeasureResult";

class ICAS extends MainMeasureResult {
  constructor(refMarkupData) {
    super('ICAS', refMarkupData);
  }

  recalculateValue() {
    // Tear drop
    const tearDrop = this.getTearDrop();

    // Femoral head
    const femoralHead = this.getFemoralHead();

    // Acetabulum
    const acetabulum = this.getAcetabulum();

    const ISA = (acetabulum.radius * 2) / (tearDrop.length / 2);
    const ISH = (femoralHead.radius * 2) / (tearDrop.length / 2);

    return ISA / ISH;
  }

  recalculateShapes() {
    this.shapes.push(this.getLine('tearDrop', tearDropPointTypes));
    this.shapes.push(this.getCircle('ac', acetabulumPointTypes, 'Ra'));
    this.shapes.push(this.getCircle('femoral', femoralHeadPointTypes, 'Rh'));
  }

}

export default ICAS;